const tallyLoaded = ref(false)

export const useTally = () => {
	!tallyLoaded.value &&
		useHead({
			script: [
				{
					src: 'https://tally.so/widgets/embed.js',
					type: 'text/javascript',
					async: true,
					onload: () => {
						tallyLoaded.value = true
					},
				},
			],
		})

	return tallyLoaded
}
